<script>
import baseMixins from '@/plans/ZOOM_MEETING/config/base';
import { mapGetters } from 'vuex';
import { BILLING_CYCLE, planTypes, maxBizAndBizPlusLicenseCount } from '@/common/constants';
import { get } from 'lodash';

export default {
  mixins: [baseMixins],
  data() {
    return {
      showCategoryDesc: true,
    };
  },
  computed: {
    ...mapGetters(['boughtPlans', 'basicConfig', 'disableMonthly2AnnualTip']),
    boughtZonePlan() {
      return this.boughtPlans.find((p) => p.type === planTypes.ZOOM_MEETING);
    },
    maxHost() {
      const defaultMaxHosts = this.formPlan ? this.formPlan.max : maxBizAndBizPlusLicenseCount;
      const boughtZonePlanQuantity = get(this.boughtZonePlan, 'cartInfo.selected_number', defaultMaxHosts);
      return Math.max(boughtZonePlanQuantity, defaultMaxHosts);
    },
    isNormalCase() {
      const boughtZonePlanQuantity = get(this.boughtZonePlan, 'cartInfo.selected_number', 0);
      const defaultMaxHosts = this.formPlan ? this.formPlan.max : maxBizAndBizPlusLicenseCount;
      return boughtZonePlanQuantity <= defaultMaxHosts;
    },
  },
  methods: {
    billingCycleDisabled({ billing_cycle }) {
      if (this.disableMonthly2AnnualTip && billing_cycle === BILLING_CYCLE.ANNUAL) {
        return this.disableMonthly2AnnualTip;
      }

      return this.getBillingCycleDisabledDesc(billing_cycle);
    },
  },
};
</script>
